var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "photon-brand-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 270,
    height: 60,
    viewBox: "0 0 270 60",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @media (prefers-color-scheme: dark) {\n      .photon-brand-logo stop[stop-color=\"#3D0080\"] { stop-color: color-mix(in srgb, #3D0080 60%, white); }\n      .photon-brand-logo stop[stop-color=\"#8B1FCC\"] { stop-color: color-mix(in srgb, #8B1FCC 80%, white); }\n    }\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D0080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#8B1FCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F05A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A623"
  })), /*#__PURE__*/React.createElement("path", {
    id: "photon-logo-contour",
    "data-name": "Union 14",
    d: "M48.756,59.959l-.168-.015H12.357A12.221,12.221,0,0,1,1.672,53.8a12.119,12.119,0,0,1,0-12.287L22.179,6.143a12.514,12.514,0,0,1,1.97-2.569A12.128,12.128,0,0,1,29.577.432,12.594,12.594,0,0,1,32.791,0h.146a12.6,12.6,0,0,1,3.214.432,12.126,12.126,0,0,1,5.428,3.142,12.515,12.515,0,0,1,1.97,2.569L64.055,41.514A12.287,12.287,0,0,1,53.37,59.944H50.792A10.733,10.733,0,0,1,49.7,60C49.385,60,49.068,59.986,48.756,59.959ZM56.04,44.732A12.036,12.036,0,0,1,53.634,56.3a10.7,10.7,0,0,1-2.707,2.222,9.653,9.653,0,0,1-1.333.632h1.151A9.937,9.937,0,0,0,52.82,58.7a10.1,10.1,0,0,0,1.946-.885,10.447,10.447,0,0,0,1.746-1.294A10.979,10.979,0,0,0,58,54.847a11.232,11.232,0,0,0,1.178-11.195L46.668,15.237ZM2.362,53.4a11.433,11.433,0,0,0,10,5.747H39.491l-27.507-2.4a10.955,10.955,0,0,1-8.931-6.29A12.385,12.385,0,0,1,2.2,48.121a11.942,11.942,0,0,1-.215-4.828q.093-.576.242-1.145A11.331,11.331,0,0,0,2.362,53.4ZM59.909,43.333a12.016,12.016,0,0,1-1.261,11.976,11.831,11.831,0,0,1-1.342,1.558,11.346,11.346,0,0,1-1.553,1.266,11.013,11.013,0,0,1-1.726.954l-.121.052a11.493,11.493,0,0,0,9.459-17.229L46.386,12.623Zm-7.453,2.421a11.823,11.823,0,0,1-3.42,11.05,9.6,9.6,0,0,1-2.484,1.682,8.585,8.585,0,0,1-1.02.4l.98.085a8.412,8.412,0,0,0,1.782-.239,8.633,8.633,0,0,0,1.714-.62,9.272,9.272,0,0,0,1.594-.989,10.319,10.319,0,0,0,1.436-1.346,11.241,11.241,0,0,0,2.244-10.8L46.651,17.81Zm-3.3.688a12.119,12.119,0,0,1-.839,5.864,11.474,11.474,0,0,1-1.431,2.531,10.278,10.278,0,0,1-2.016,2.035,8.649,8.649,0,0,1-1.776,1.043,7.674,7.674,0,0,1-1.186.4l.764.138c.141.008.284.013.424.013a7.343,7.343,0,0,0,2.816-.568,8.688,8.688,0,0,0,2.581-1.676,11.029,11.029,0,0,0,3.182-10.309l-5.318-25.6ZM3.771,50.122a10.166,10.166,0,0,0,8.283,5.843l23.9,2.082-24.04-4.34a9.356,9.356,0,0,1-4.461-2.118A10,10,0,0,1,5.76,49.713a11.257,11.257,0,0,1-1.241-2.341,11.9,11.9,0,0,1-.637-2.284,12.119,12.119,0,0,1,.1-4.658c.08-.366.177-.728.29-1.084A11.223,11.223,0,0,0,3.771,50.122Zm42.371-3.287a12.178,12.178,0,0,1-.322,2.945,11.915,11.915,0,0,1-.991,2.707A10.878,10.878,0,0,1,43.246,54.8a9.439,9.439,0,0,1-2.1,1.755,7.591,7.591,0,0,1-1.772.8,6.6,6.6,0,0,1-.653.16l.559.158a6.066,6.066,0,0,0,.9.067,6.979,6.979,0,0,0,4.2-1.5,9.489,9.489,0,0,0,1.863-1.882A10.683,10.683,0,0,0,47.583,52a11.331,11.331,0,0,0,.782-5.476l-2.548-23.8Zm-2.736.136a12.038,12.038,0,0,1-.561,2.828,11.829,11.829,0,0,1-1.175,2.544,10.4,10.4,0,0,1-1.689,2.093,8.349,8.349,0,0,1-2.107,1.472,6.309,6.309,0,0,1-1.964.6l.449.178a5.073,5.073,0,0,0,1.217.148h0a5.492,5.492,0,0,0,1.576-.237,6.784,6.784,0,0,0,1.58-.715,8.648,8.648,0,0,0,1.924-1.612,10.076,10.076,0,0,0,1.465-2.144,11.118,11.118,0,0,0,.923-2.525,11.393,11.393,0,0,0,.3-2.751l-.294-21.818Zm-38.145.113a10.454,10.454,0,0,0,1.15,2.172,9.23,9.23,0,0,0,1.554,1.729,8.56,8.56,0,0,0,4.087,1.942l20.836,3.762-20.8-5.874a8.954,8.954,0,0,1-6.046-6.31A11.835,11.835,0,0,1,5.6,42.291,12.06,12.06,0,0,1,5.98,37.87q.133-.479.3-.946A11.281,11.281,0,0,0,5.261,47.085Zm35.681-.2a12.11,12.11,0,0,1-.762,2.7,11.443,11.443,0,0,1-1.308,2.354A9.623,9.623,0,0,1,37.123,53.8,7.441,7.441,0,0,1,35.034,55a5.479,5.479,0,0,1-1.567.335l.321.168a4.311,4.311,0,0,0,1.453.25,5.256,5.256,0,0,0,2.288-.557,7.574,7.574,0,0,0,1.914-1.34A9.6,9.6,0,0,0,41,51.921a11.033,11.033,0,0,0,1.092-2.37,11.266,11.266,0,0,0,.522-2.638L44.091,27.19ZM6.808,44.278a8.174,8.174,0,0,0,5.5,5.775l17.962,5.073L12.489,48.091a8.3,8.3,0,0,1-4.872-6.238,11.816,11.816,0,0,1-.253-2.891,11.965,11.965,0,0,1,.908-4.171A11.185,11.185,0,0,0,6.808,44.278ZM31.589,54.19a3.683,3.683,0,0,0,1.6.359,4.558,4.558,0,0,0,1.568-.294,6.66,6.66,0,0,0,1.875-1.081,8.818,8.818,0,0,0,1.6-1.706,10.632,10.632,0,0,0,1.211-2.187,11.336,11.336,0,0,0,.709-2.519l2.809-17.571L38.74,46.615a11.822,11.822,0,0,1-.93,2.529A11.182,11.182,0,0,1,36.4,51.3a9.03,9.03,0,0,1-1.773,1.634,6.426,6.426,0,0,1-2.016.949,4.744,4.744,0,0,1-1.2.159h-.04ZM8.556,36.4A11.161,11.161,0,0,0,8.4,41.688a7.52,7.52,0,0,0,4.387,5.667L28.069,53.4l-15-7.86A7.8,7.8,0,0,1,9.22,39.4a11.569,11.569,0,0,1-.014-2.779,12.189,12.189,0,0,1,.626-2.7q.193-.544.436-1.064A10.839,10.839,0,0,0,8.556,36.4ZM29.734,52.78a3.117,3.117,0,0,0,.79.349,3.266,3.266,0,0,0,.891.121,3.939,3.939,0,0,0,.991-.132,5.656,5.656,0,0,0,1.78-.843A8.216,8.216,0,0,0,35.8,50.781a10.374,10.374,0,0,0,1.3-2,11.058,11.058,0,0,0,.864-2.352L41.7,31.017,36.788,46.185a11.7,11.7,0,0,1-1.063,2.356,10.629,10.629,0,0,1-1.472,1.949A8.208,8.208,0,0,1,32.494,51.9a5.619,5.619,0,0,1-1.929.72,4.214,4.214,0,0,1-.674.055q-.149,0-.3-.011Zm-1.525-1.458a2.646,2.646,0,0,0,1.667.56,3.5,3.5,0,0,0,.56-.047,4.853,4.853,0,0,0,1.673-.63,7.408,7.408,0,0,0,1.584-1.276,9.834,9.834,0,0,0,1.352-1.8,10.94,10.94,0,0,0,.984-2.187l4.307-13.288L35.074,45.626a11.473,11.473,0,0,1-1.162,2.168,10.045,10.045,0,0,1-1.5,1.741,7.433,7.433,0,0,1-1.717,1.2,4.9,4.9,0,0,1-1.82.517c-.085.006-.172.009-.259.009a3.449,3.449,0,0,1-.5-.036ZM11.705,31.9a10.949,10.949,0,0,0-1.125,2.29A11.4,11.4,0,0,0,10,36.711a10.793,10.793,0,0,0,.013,2.59,7.022,7.022,0,0,0,3.428,5.539l12.808,6.711L13.792,43.172a7.44,7.44,0,0,1-2.947-6.031,11.594,11.594,0,0,1,.2-2.658,12.1,12.1,0,0,1,.779-2.531q.148-.341.315-.67Q11.913,31.581,11.705,31.9ZM26.949,49.807a2.261,2.261,0,0,0,.739.487,2.462,2.462,0,0,0,.923.17c.068,0,.138,0,.208-.007a4.135,4.135,0,0,0,1.546-.446,6.636,6.636,0,0,0,1.529-1.074,9.267,9.267,0,0,0,1.369-1.6,10.738,10.738,0,0,0,1.073-2.008L38.9,34.089,33.583,44.964a11.166,11.166,0,0,1-1.215,1.953,9.475,9.475,0,0,1-1.481,1.529,6.786,6.786,0,0,1-1.635,1,4.34,4.34,0,0,1-1.682.366H27.5a3.1,3.1,0,0,1-.6-.069ZM13.755,30.17a10.634,10.634,0,0,0-1.2,2.1,11.3,11.3,0,0,0-.726,2.362,10.8,10.8,0,0,0-.186,2.476,6.666,6.666,0,0,0,2.6,5.407l10.538,7.091-10.14-8.623a7.2,7.2,0,0,1-2.15-5.919,11.562,11.562,0,0,1,.341-2.3A12.016,12.016,0,0,1,13.6,30.59q.159-.338.337-.662Q13.846,30.047,13.755,30.17ZM25.949,48.28a1.972,1.972,0,0,0,.673.54,2.139,2.139,0,0,0,.892.2h.05a3.59,3.59,0,0,0,1.4-.311,5.989,5.989,0,0,0,1.44-.894,8.686,8.686,0,0,0,1.344-1.4,10.417,10.417,0,0,0,1.119-1.8l4.545-9.3L32.3,44.22a10.76,10.76,0,0,1-1.193,1.686,9.017,9.017,0,0,1-1.386,1.305,6.426,6.426,0,0,1-1.485.85,4.081,4.081,0,0,1-1.5.307,3.19,3.19,0,0,1-.335-.018,2.744,2.744,0,0,1-.469-.091Zm-11.455-17.7a11.169,11.169,0,0,0-.845,2.185,10.817,10.817,0,0,0-.368,2.336,6.433,6.433,0,0,0,1.872,5.281l8.477,7.209-8.059-8.616a5.035,5.035,0,0,1-.8-1.143,6.317,6.317,0,0,1-.509-1.384,8.019,8.019,0,0,1-.216-1.572,9.877,9.877,0,0,1,.084-1.711,11.558,11.558,0,0,1,.473-2.059,11.882,11.882,0,0,1,.822-1.92q.1-.193.214-.381A10.3,10.3,0,0,0,14.494,30.577ZM25.728,47.31a1.785,1.785,0,0,0,.763.253,2.431,2.431,0,0,0,.255.013,3.308,3.308,0,0,0,1.225-.259,5.63,5.63,0,0,0,1.3-.752,8.239,8.239,0,0,0,1.25-1.188,10.052,10.052,0,0,0,1.094-1.551l4.306-7.5-4.7,7.094a10.267,10.267,0,0,1-1.151,1.442,8.538,8.538,0,0,1-1.287,1.105,6.085,6.085,0,0,1-1.345.714,3.863,3.863,0,0,1-1.331.257,2.838,2.838,0,0,1-.537-.05,2.47,2.47,0,0,1-.363-.1A1.748,1.748,0,0,0,25.728,47.31Zm-.664-1.488a1.508,1.508,0,0,0,.649.285,2.094,2.094,0,0,0,.394.036,3.082,3.082,0,0,0,1.074-.214,5.3,5.3,0,0,0,1.164-.628,7.772,7.772,0,0,0,1.154-1,9.567,9.567,0,0,0,1.051-1.32l3.884-5.859L30.3,42.574a8.928,8.928,0,0,1-2.279,2.146,4.606,4.606,0,0,1-2.4.807,2.6,2.6,0,0,1-.689-.09,2.21,2.21,0,0,1-.276-.1A1.555,1.555,0,0,0,25.064,45.822ZM16.39,29.1a11,11,0,0,0-.939,1.993,10.813,10.813,0,0,0-.528,2.173,9.106,9.106,0,0,0-.078,1.563,7.235,7.235,0,0,0,.19,1.413,5.524,5.524,0,0,0,.442,1.215,4.244,4.244,0,0,0,.676.974l6.631,7.09-6.21-8.38a4.821,4.821,0,0,1-.628-1.165,6.239,6.239,0,0,1-.34-1.372,8.072,8.072,0,0,1-.054-1.528,10.036,10.036,0,0,1,.234-1.638,11.518,11.518,0,0,1,.583-1.838,11.67,11.67,0,0,1,.863-1.692l0-.007A10.084,10.084,0,0,0,16.39,29.1Zm8.2,15.26a1.283,1.283,0,0,0,.557.31,1.832,1.832,0,0,0,.487.063,2.888,2.888,0,0,0,.943-.176,4.965,4.965,0,0,0,1.041-.519A8.194,8.194,0,0,0,29.669,42.1l3.324-4.39-3.434,4a9.4,9.4,0,0,1-1.025,1.026,7.488,7.488,0,0,1-1.076.769,5.346,5.346,0,0,1-1.082.488,3.51,3.51,0,0,1-1.047.172,2.438,2.438,0,0,1-.83-.138,2.02,2.02,0,0,1-.2-.086A1.4,1.4,0,0,0,24.592,44.363ZM18.229,27.837a10.835,10.835,0,0,0-1.667,3.777,9.24,9.24,0,0,0-.215,1.5,7.286,7.286,0,0,0,.045,1.373,5.458,5.458,0,0,0,.294,1.2,4.046,4.046,0,0,0,.529.986l5.008,6.758-4.6-7.944a4.7,4.7,0,0,1-.476-1.182,6.235,6.235,0,0,1-.187-1.358,8.171,8.171,0,0,1,.1-1.486,10.2,10.2,0,0,1,.374-1.569,11.668,11.668,0,0,1,.661-1.625c.168-.337.352-.666.551-.981Q18.429,27.55,18.229,27.837Zm6.065,15.115a1.1,1.1,0,0,0,.476.325,1.615,1.615,0,0,0,.547.089,3.6,3.6,0,0,0,1.755-.566,7.641,7.641,0,0,0,1.881-1.61l2.664-3.1-2.657,2.737a8.693,8.693,0,0,1-.946.845,6.973,6.973,0,0,1-.974.63,5.062,5.062,0,0,1-.967.4,3.38,3.38,0,0,1-.927.14,2.242,2.242,0,0,1-.921-.185c-.05-.022-.1-.046-.145-.072A1.267,1.267,0,0,0,24.295,42.952Zm-.146-1.359a.946.946,0,0,0,.4.338,1.43,1.43,0,0,0,.586.113,3.411,3.411,0,0,0,1.545-.456,7.068,7.068,0,0,0,1.706-1.313l1.944-2L28.5,39.948a8.033,8.033,0,0,1-.861.686,6.5,6.5,0,0,1-.873.508,4.8,4.8,0,0,1-.858.318,3.273,3.273,0,0,1-.818.112,2.081,2.081,0,0,1-.994-.231q-.046-.025-.09-.052A1.191,1.191,0,0,0,24.149,41.593ZM19.992,26.758a10.578,10.578,0,0,0-1.8,3.374,9.418,9.418,0,0,0-.344,1.436,7.381,7.381,0,0,0-.089,1.336,5.442,5.442,0,0,0,.159,1.189,3.926,3.926,0,0,0,.4,1l3.609,6.236L18.7,34a4.653,4.653,0,0,1-.335-1.195,6.282,6.282,0,0,1-.045-1.341,8.29,8.29,0,0,1,.234-1.443,10.361,10.361,0,0,1,.506-1.5,11.4,11.4,0,0,1,.712-1.406q.119-.2.245-.391ZM24.129,40.3a.83.83,0,0,0,.342.34,1.336,1.336,0,0,0,.625.135,2.49,2.49,0,0,0,.583-.075,3.782,3.782,0,0,0,.688-.244,6.346,6.346,0,0,0,1.593-1.1l1.189-1.086-1,.8a5.136,5.136,0,0,1-3.017,1.287,1.95,1.95,0,0,1-1.056-.277l-.046-.03A1.078,1.078,0,0,0,24.129,40.3Zm.089-1.219a.739.739,0,0,0,.288.339,1.217,1.217,0,0,0,.644.155,2.384,2.384,0,0,0,.506-.059,3.541,3.541,0,0,0,.6-.191,5.8,5.8,0,0,0,1.4-.86l.434-.351-.171.122a6.145,6.145,0,0,1-1.355.744,3.578,3.578,0,0,1-1.271.261,2.176,2.176,0,0,1-.6-.079,1.657,1.657,0,0,1-.521-.251l-.008-.006A.994.994,0,0,0,24.218,39.084ZM19.8,28.826a9.6,9.6,0,0,0-.465,1.375,7.517,7.517,0,0,0-.214,1.3,5.488,5.488,0,0,0,.035,1.175,3.88,3.88,0,0,0,.279,1.005l2.441,5.554-2.08-6.561a4.66,4.66,0,0,1-.205-1.2,6.357,6.357,0,0,1,.087-1.32,8.423,8.423,0,0,1,.364-1.4,10.492,10.492,0,0,1,.63-1.429c.152-.286.317-.567.493-.838A10.436,10.436,0,0,0,19.8,28.826Zm4.6,9.112a.663.663,0,0,0,.241.334,1.079,1.079,0,0,0,.645.175,3.964,3.964,0,0,0,2.084-.8,5.247,5.247,0,0,1-.768.332,3.457,3.457,0,0,1-1.093.2,2.12,2.12,0,0,1-.631-.09,1.558,1.558,0,0,1-.507-.264A.891.891,0,0,0,24.4,37.938Zm7.335-13.587a3.623,3.623,0,0,0-.582.188,5.229,5.229,0,0,0-.9.483,6.04,6.04,0,0,0-.817.654,5.474,5.474,0,0,0-.665.759,3.848,3.848,0,0,0-.447.79l-3.508,8.634-.156.479a1.212,1.212,0,0,0-.009.53.6.6,0,0,0,.2.328.778.778,0,0,0,.273.143,1.315,1.315,0,0,0,.385.052,3.7,3.7,0,0,0,1.838-.642l9.745-6.08a6.077,6.077,0,0,0,1.021-.8,5.1,5.1,0,0,0,.714-.859,3.5,3.5,0,0,0,.4-.814,1.7,1.7,0,0,0,.1-.644.611.611,0,0,0-.4-.568l-6.213-2.611a1.235,1.235,0,0,0-.48-.085A2.3,2.3,0,0,0,31.734,24.351ZM21.375,27.7A9.472,9.472,0,0,0,20.8,29a7.773,7.773,0,0,0-.331,1.265,5.712,5.712,0,0,0-.083,1.166,3.815,3.815,0,0,0,.165,1.006l1.5,4.74L20.882,31.5a4.646,4.646,0,0,1-.085-1.133,6.323,6.323,0,0,1,.169-1.187,8.242,8.242,0,0,1,.387-1.2,9.835,9.835,0,0,1,.572-1.174q.06-.106.124-.21A10.2,10.2,0,0,0,21.375,27.7Zm.452,1.387a5.9,5.9,0,0,0-.223,1.187,3.871,3.871,0,0,0,.058,1.075l.792,3.823-.5-4.685a4.643,4.643,0,0,1,.017-1.07,6.315,6.315,0,0,1,.246-1.1,8.137,8.137,0,0,1,.44-1.1q.062-.129.13-.257A8.813,8.813,0,0,0,21.826,29.083ZM22.868,6.539l-.028.048L7.388,33.24l18-26.9,0,0a11.883,11.883,0,0,1,1.657-1.9,11.143,11.143,0,0,1,2.2-1.582A10.7,10.7,0,0,1,34.4,1.545c.317,0,.639.014.956.042a10.9,10.9,0,0,1,2.382.478,10.662,10.662,0,0,1,1.459.591,11.611,11.611,0,0,0-16.33,3.883Zm.213,21.734a5.882,5.882,0,0,0-.3,1.1,3.865,3.865,0,0,0-.038,1.021l.3,2.835L23,29.6a4.652,4.652,0,0,1,.1-1,6.261,6.261,0,0,1,.308-1.017q.068-.172.147-.346A7.951,7.951,0,0,0,23.081,28.273Zm1.186-.656a5.84,5.84,0,0,0-.354,1.015,3.883,3.883,0,0,0-.117.957l.023,1.8.192-2.546a4.67,4.67,0,0,1,.173-.935c.038-.133.083-.267.133-.4ZM31.924,2.651a9.958,9.958,0,0,0-2.3.911,10.35,10.35,0,0,0-2.039,1.469,11.128,11.128,0,0,0-1.7,1.989l-15.5,23.162L28.1,7.007l0,0a11.2,11.2,0,0,1,1.477-1.523A10.237,10.237,0,0,1,31.485,4.2a9.552,9.552,0,0,1,2.1-.793A9.257,9.257,0,0,1,35.8,3.135a9.373,9.373,0,0,1,4.68,1.251q-.11-.085-.223-.166a9.887,9.887,0,0,0-2.336-1.251,10.037,10.037,0,0,0-2.637-.592c-.3-.026-.593-.038-.885-.038A9.951,9.951,0,0,0,31.924,2.651ZM24.988,28.014a3.876,3.876,0,0,0-.182.891l-.058.762.233-1.455a4.36,4.36,0,0,1,.1-.468Q25.031,27.88,24.988,28.014Zm15.559.771h0Zm.866-1.055h0ZM33.774,4.176a8.758,8.758,0,0,0-1.925.729,9.441,9.441,0,0,0-1.76,1.186,10.46,10.46,0,0,0-1.533,1.621L13.387,27.57l16.9-19.511a10.543,10.543,0,0,1,1.486-1.415,9.4,9.4,0,0,1,1.655-1.036A8.547,8.547,0,0,1,35.2,4.972a7.975,7.975,0,0,1,3.845.039,8.214,8.214,0,0,1,1.8.7q.346.184.674.4L41.5,6.09a8.6,8.6,0,0,0-5.694-2.161A8.459,8.459,0,0,0,33.774,4.176ZM16.836,26.91h0Zm22.4-.653a1.46,1.46,0,0,1,.506.345.691.691,0,0,0-.438-.332l-.136-.041Zm3.007.279v0ZM39.54,25.512a1.54,1.54,0,0,1,.723.45l.028.033a.76.76,0,0,0-.2-.3.9.9,0,0,0-.445-.211l-.61-.122Zm-23.218-.117L32.339,9.024a9.789,9.789,0,0,1,1.32-1.133,8.613,8.613,0,0,1,1.428-.825,7.706,7.706,0,0,1,1.5-.5,7.086,7.086,0,0,1,1.538-.171,6.839,6.839,0,0,1,2.232.375,7.225,7.225,0,0,1,1.565.761q.214.138.42.293A7.653,7.653,0,0,0,40.8,6.594a7.4,7.4,0,0,0-1.952-.816,7.186,7.186,0,0,0-1.8-.229,7.261,7.261,0,0,0-1.668.2,7.764,7.764,0,0,0-1.612.578,8.6,8.6,0,0,0-1.513.948A9.737,9.737,0,0,0,30.89,8.576l-.335.387h0Zm23.484-.69a1.689,1.689,0,0,1,.834.408,1.484,1.484,0,0,1,.168.185c0-.014-.008-.028-.013-.041a.878.878,0,0,0-.3-.436,1.09,1.09,0,0,0-.552-.2L38.791,24.5Zm3.224.5v0Zm-22.037-.52h0Zm19.036-.851a1.872,1.872,0,0,1,.957.358,1.577,1.577,0,0,1,.32.329,1.37,1.37,0,0,0-.061-.182.979.979,0,0,0-.387-.47,1.31,1.31,0,0,0-.676-.174l-1.766-.031Zm-6.084.5h0l-.012,0Zm-11.089-.387h0Zm10.533-.018h0l-.011,0Zm10.354-.188v0ZM40.35,22.7l-2.457.162,2.3.04a2.091,2.091,0,0,1,1.093.3,1.693,1.693,0,0,1,.49.466,1.578,1.578,0,0,0-.118-.323,1.115,1.115,0,0,0-.446-.481A1.437,1.437,0,0,0,40.5,22.7C40.452,22.7,40.4,22.7,40.35,22.7ZM36.761,7.337a6.908,6.908,0,0,0-1.348.454,7.83,7.83,0,0,0-1.295.749,8.994,8.994,0,0,0-1.2,1.03l-.007.007L19.156,23.634,34.1,10.1a8.53,8.53,0,0,1,2.379-1.552A6.432,6.432,0,0,1,39,8.014a5.968,5.968,0,0,1,2.381.5,6.227,6.227,0,0,1,1.362.811q.132.1.259.214A6.8,6.8,0,0,0,41.792,8.4,6.417,6.417,0,0,0,40.1,7.515a6.034,6.034,0,0,0-1.97-.33A6.3,6.3,0,0,0,36.761,7.337ZM32.728,23.563h-.011Zm-8.146-.157h0Zm7.375-.151h-.01Zm-5.8-.2h0Zm4.895-.038h.009Zm-1.018-.158h.008Zm-2.444,0H27.6Zm1.294-.059h.007Zm11.7-.892a2.193,2.193,0,0,1,1.038.278,1.861,1.861,0,0,1,.615.571,1.939,1.939,0,0,0-.2-.485,1.278,1.278,0,0,0-.5-.486,1.555,1.555,0,0,0-.739-.166,2.537,2.537,0,0,0-.363.028l-3.228.471,3.375-.223Zm-3.8-12.626a7.733,7.733,0,0,0-2.148,1.406l-.111.1L21.853,22.263,35.591,11.249a7.812,7.812,0,0,1,2.048-1.2,5.816,5.816,0,0,1,2.107-.41,5.149,5.149,0,0,1,2.409.6,5.56,5.56,0,0,1,1.172.824l.037.034a6.137,6.137,0,0,0-.874-.946,5.462,5.462,0,0,0-1.424-.9A5.171,5.171,0,0,0,39,8.808,5.652,5.652,0,0,0,36.784,9.278Zm7.58,12.86v0Zm-2.451-1.052a2.035,2.035,0,0,1,.73.659,2.148,2.148,0,0,0-.293-.634,1.481,1.481,0,0,0-.555-.491,1.7,1.7,0,0,0-.767-.166,2.814,2.814,0,0,0-.606.071h0l-4.08.913,3.98-.581a3.259,3.259,0,0,1,.47-.035A2.362,2.362,0,0,1,41.913,21.086Zm-5.822-9.22-11.7,9.384,12.678-8.958,0,0a6.964,6.964,0,0,1,1.509-.756,5.294,5.294,0,0,1,1.751-.31,4.492,4.492,0,0,1,2.389.679,4.987,4.987,0,0,1,.942.757,5.481,5.481,0,0,0-.663-.829,4.808,4.808,0,0,0-1.209-.9,4.354,4.354,0,0,0-2.038-.5A5.918,5.918,0,0,0,36.09,11.866Zm4.2,7.493-5.012,1.505,4.968-1.111a3.566,3.566,0,0,1,.775-.09,2.52,2.52,0,0,1,1.133.252,2.252,2.252,0,0,1,.851.743q-.013-.043-.028-.084a2.349,2.349,0,0,0-.376-.7,1.7,1.7,0,0,0-.62-.49,1.934,1.934,0,0,0-.813-.167A3.071,3.071,0,0,0,40.288,19.359ZM38.832,12.29a6.312,6.312,0,0,0-1.538.81L26.735,20.561l11.114-6.871.007,0,.234-.145,0,0a6.285,6.285,0,0,1,1.215-.533,4.839,4.839,0,0,1,1.442-.229,4.043,4.043,0,0,1,1.227.187,3.953,3.953,0,0,1,1.113.562,4.37,4.37,0,0,1,.731.668,4.936,4.936,0,0,0-.488-.709,4.263,4.263,0,0,0-1.038-.91,3.7,3.7,0,0,0-1.969-.559A4.505,4.505,0,0,0,38.832,12.29Zm1.194,5.858-.046.017L34,20.418l6.328-1.9,0,.008a3.713,3.713,0,0,1,.837-.1,2.532,2.532,0,0,1,2.05.957q.051.064.1.132-.037-.105-.08-.205a2.644,2.644,0,0,0-.474-.748,1.976,1.976,0,0,0-.685-.49,2.164,2.164,0,0,0-.852-.165A3.436,3.436,0,0,0,40.026,18.148Zm4.843,2.264v0Zm-5.329-6.64a5.637,5.637,0,0,0-1.271.592L28.877,20.17l9.782-5.231a5.807,5.807,0,0,1,1.2-.486,4.444,4.444,0,0,1,1.172-.164,3.629,3.629,0,0,1,1.211.2,3.471,3.471,0,0,1,1.065.607,3.938,3.938,0,0,1,.505.5,4.464,4.464,0,0,0-.335-.558,3.7,3.7,0,0,0-.853-.87,3.151,3.151,0,0,0-.888-.448,3.255,3.255,0,0,0-.986-.149A4.052,4.052,0,0,0,39.539,13.772Zm.075,3.131-7.1,3.228,7.226-2.725a4.244,4.244,0,0,1,1.491-.294,2.934,2.934,0,0,1,1.163.23,2.778,2.778,0,0,1,.957.685,3.132,3.132,0,0,1,.2.247q-.064-.161-.139-.309a2.907,2.907,0,0,0-.581-.794,2.314,2.314,0,0,0-.754-.486,2.439,2.439,0,0,0-.894-.162A3.835,3.835,0,0,0,39.615,16.9Zm.459-1.691a5.154,5.154,0,0,0-1.032.422l-.138.074-8.1,4.33,8.478-3.856.006,0,.255-.116,0,.006a4.465,4.465,0,0,1,1.647-.342,3.212,3.212,0,0,1,1.183.218,3.121,3.121,0,0,1,1.011.651,3.582,3.582,0,0,1,.353.391,4.03,4.03,0,0,0-.234-.448,3.318,3.318,0,0,0-.711-.834,2.733,2.733,0,0,0-.826-.475,2.772,2.772,0,0,0-.937-.158A3.6,3.6,0,0,0,40.073,15.213Zm5.161,3.353v0Zm.2-1.954h0V16.6Zm.008-2.047h0l0-.01Zm-.21-2.125h0l0-.01Zm-.462-2.2h0l-.005-.012ZM44,7.96h0L44,7.946Z",
    fill: "url(#linear-gradient)",
    "data-photon-outline": ""
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(158 1415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M30.563-165.91q9.239,0,14.206,3.513t4.967,10.474a14.236,14.236,0,0,1-1.36,6.487,11.164,11.164,0,0,1-3.923,4.367,17.911,17.911,0,0,1-6.233,2.437,41.094,41.094,0,0,1-8.289.759H25.058v16.265H18.92v-43.226a34.6,34.6,0,0,1,5.79-.854Q27.905-165.91,30.563-165.91Zm.506,5.38q-3.923,0-6.011.19v17.214h4.619a35.709,35.709,0,0,0,5.695-.411,12.874,12.874,0,0,0,4.271-1.392,6.87,6.87,0,0,0,2.689-2.69,8.928,8.928,0,0,0,.949-4.367,8.055,8.055,0,0,0-.981-4.177,7.378,7.378,0,0,0-2.658-2.626,11.485,11.485,0,0,0-3.892-1.361A27.7,27.7,0,0,0,31.069-160.531Zm24.678,38.922v-48.1l5.885-1.013v16.835a19.941,19.941,0,0,1,3.512-.981,20.156,20.156,0,0,1,3.7-.348,16.67,16.67,0,0,1,6.518,1.108,10.2,10.2,0,0,1,4.145,3.1,12,12,0,0,1,2.183,4.778,27.728,27.728,0,0,1,.633,6.139v18.48H76.439v-17.214a28.1,28.1,0,0,0-.411-5.19,8.775,8.775,0,0,0-1.36-3.481,5.384,5.384,0,0,0-2.531-1.93,11.117,11.117,0,0,0-3.923-.6,15.807,15.807,0,0,0-1.962.127q-1.012.127-1.93.285t-1.645.348a9.782,9.782,0,0,0-1.044.316v27.34Zm63.91-16.455a20.823,20.823,0,0,1-1.139,7.088,16.21,16.21,0,0,1-3.2,5.443,14.057,14.057,0,0,1-4.9,3.512,15.426,15.426,0,0,1-6.2,1.234,15.426,15.426,0,0,1-6.2-1.234,14.057,14.057,0,0,1-4.9-3.512,16.211,16.211,0,0,1-3.2-5.443,20.822,20.822,0,0,1-1.139-7.088,20.9,20.9,0,0,1,1.139-7.057,16.155,16.155,0,0,1,3.2-5.474,14.055,14.055,0,0,1,4.9-3.512,15.426,15.426,0,0,1,6.2-1.234,15.426,15.426,0,0,1,6.2,1.234,14.055,14.055,0,0,1,4.9,3.512,16.154,16.154,0,0,1,3.2,5.474A20.9,20.9,0,0,1,119.658-138.063Zm-6.138,0q0-5.569-2.5-8.829a8.113,8.113,0,0,0-6.8-3.259,8.113,8.113,0,0,0-6.8,3.259q-2.5,3.259-2.5,8.829t2.5,8.829a8.114,8.114,0,0,0,6.8,3.259,8.113,8.113,0,0,0,6.8-3.259Q113.52-132.494,113.52-138.063Zm18.667-16.455h12.466v4.937H132.187v15.189a18.258,18.258,0,0,0,.38,4.082,6.132,6.132,0,0,0,1.139,2.532,4.1,4.1,0,0,0,1.9,1.3,8.413,8.413,0,0,0,2.658.38,12.5,12.5,0,0,0,4.271-.6q1.614-.6,2.246-.854l1.139,4.873a21.844,21.844,0,0,1-3.1,1.108,17.627,17.627,0,0,1-5.062.665,15.343,15.343,0,0,1-5.537-.854,8.064,8.064,0,0,1-3.512-2.563,10.266,10.266,0,0,1-1.867-4.209,27.746,27.746,0,0,1-.538-5.791v-29.366l5.885-1.013Zm46.825,16.455a20.822,20.822,0,0,1-1.139,7.088,16.21,16.21,0,0,1-3.2,5.443,14.057,14.057,0,0,1-4.9,3.512,15.426,15.426,0,0,1-6.2,1.234,15.426,15.426,0,0,1-6.2-1.234,14.057,14.057,0,0,1-4.9-3.512,16.211,16.211,0,0,1-3.2-5.443,20.822,20.822,0,0,1-1.139-7.088,20.9,20.9,0,0,1,1.139-7.057,16.154,16.154,0,0,1,3.2-5.474,14.056,14.056,0,0,1,4.9-3.512,15.426,15.426,0,0,1,6.2-1.234,15.426,15.426,0,0,1,6.2,1.234,14.056,14.056,0,0,1,4.9,3.512,16.153,16.153,0,0,1,3.2,5.474A20.9,20.9,0,0,1,179.012-138.063Zm-6.138,0q0-5.569-2.5-8.829a8.114,8.114,0,0,0-6.8-3.259,8.113,8.113,0,0,0-6.8,3.259q-2.5,3.259-2.5,8.829t2.5,8.829a8.113,8.113,0,0,0,6.8,3.259,8.114,8.114,0,0,0,6.8-3.259Q172.874-132.494,172.875-138.063Zm13.162-15.506q2.025-.506,5.379-1.076a46.526,46.526,0,0,1,7.72-.57,16.67,16.67,0,0,1,6.518,1.108,10.194,10.194,0,0,1,4.145,3.1,12,12,0,0,1,2.183,4.778,27.73,27.73,0,0,1,.633,6.139v18.48h-5.885v-17.214a28.1,28.1,0,0,0-.411-5.19,8.774,8.774,0,0,0-1.36-3.481,5.383,5.383,0,0,0-2.531-1.93,11.117,11.117,0,0,0-3.923-.6q-.949,0-1.962.063t-1.93.158q-.917.095-1.645.222t-1.044.19v27.784h-5.885Z",
    transform: "translate(-100.613 -1239.173)",
    fill: "#0d3148"
  }), /*#__PURE__*/React.createElement("g", {
    "data-photon-particles": "",
    fill: "url(#linear-gradient)",
    transform: "translate(-158 -1415)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.36,
    cy: 0.72,
    r: 0.59,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.58,
    cy: 0.9,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.58,
    cy: 0.6,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.97,
    cy: 2.85,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.11,
    cy: 2.79,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.51,
    cy: 2.92,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.33,
    cy: 2.96,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.2,
    cy: 4.58,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.58,
    cy: 4.6,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.44,
    cy: 5.04,
    r: 0.53,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.32,
    cy: 4.96,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.86,
    cy: 4.7,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.38,
    cy: 4.42,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.81,
    cy: 6.72,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.43,
    cy: 6.79,
    r: 0.43,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.4,
    cy: 6.51,
    r: 0.48,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.13,
    cy: 7.01,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.57,
    cy: 6.83,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.48,
    cy: 6.54,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.92,
    cy: 9.12,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.07,
    cy: 8.8,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.56,
    cy: 8.85,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.68,
    cy: 8.48,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.47,
    cy: 8.61,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.92,
    cy: 9.08,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.05,
    cy: 10.86,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.29,
    cy: 10.92,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.41,
    cy: 11.12,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.54,
    cy: 10.6,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.94,
    cy: 11.01,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.9,
    cy: 10.81,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.43,
    cy: 10.59,
    r: 0.5,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.97,
    cy: 12.92,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.37,
    cy: 13.09,
    r: 0.4,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.02,
    cy: 13.11,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.69,
    cy: 12.97,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.47,
    cy: 12.56,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.31,
    cy: 13.04,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.31,
    cy: 13.25,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.81,
    cy: 13.23,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.76,
    cy: 13.17,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.04,
    cy: 13.09,
    r: 0.46,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.89,
    cy: 14.8,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.08,
    cy: 14.73,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.96,
    cy: 14.76,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.27,
    cy: 15.17,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.44,
    cy: 14.65,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.55,
    cy: 15.29,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.68,
    cy: 15.14,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.88,
    cy: 14.87,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.54,
    cy: 14.9,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.79,
    cy: 14.94,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.06,
    cy: 14.74,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.46,
    cy: 15,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.11,
    cy: 17.28,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.11,
    cy: 17.29,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.24,
    cy: 17.27,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.43,
    cy: 17.03,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 16.89,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.58,
    cy: 17.05,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.27,
    cy: 17.24,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.66,
    cy: 17.35,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.92,
    cy: 17.31,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.53,
    cy: 16.93,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.54,
    cy: 17.14,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.09,
    cy: 19.03,
    r: 0.59,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.32,
    cy: 19.11,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.32,
    cy: 18.91,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.39,
    cy: 19.16,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.15,
    cy: 18.88,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.44,
    cy: 18.98,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.03,
    cy: 18.93,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.26,
    cy: 18.7,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.55,
    cy: 19.09,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.79,
    cy: 19.07,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.42,
    cy: 18.95,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.39,
    cy: 19.24,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.9,
    cy: 19.19,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.75,
    cy: 19.39,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.33,
    cy: 21.43,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.05,
    cy: 21.15,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.83,
    cy: 21.31,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.47,
    cy: 20.82,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.41,
    cy: 21.38,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.51,
    cy: 21.1,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.51,
    cy: 20.82,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.33,
    cy: 21.19,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.43,
    cy: 20.95,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.6,
    cy: 21.33,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.8,
    cy: 21.45,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.39,
    cy: 20.81,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.04,
    cy: 20.93,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.62,
    cy: 20.85,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.8,
    cy: 21.29,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.83,
    cy: 23.23,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.89,
    cy: 22.9,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.12,
    cy: 23.35,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.19,
    cy: 23.39,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.31,
    cy: 23.48,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.41,
    cy: 22.89,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.58,
    cy: 23.09,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.38,
    cy: 23.44,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.27,
    cy: 23,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.22,
    cy: 23.43,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.59,
    cy: 23.39,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.57,
    cy: 23.43,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.52,
    cy: 23.19,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.85,
    cy: 23.04,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.68,
    cy: 23.05,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.76,
    cy: 23.4,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.16,
    cy: 23.31,
    r: 0.49,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.66,
    cy: 23.23,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.05,
    cy: 25.53,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.69,
    cy: 25.54,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.77,
    cy: 25.25,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.35,
    cy: 25.11,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.94,
    cy: 25.29,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.41,
    cy: 25.53,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.12,
    cy: 24.93,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.02,
    cy: 24.98,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.03,
    cy: 25,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.2,
    cy: 25.47,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.14,
    cy: 25.22,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.18,
    cy: 25.51,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.32,
    cy: 25.2,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.91,
    cy: 24.98,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.48,
    cy: 25.14,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.4,
    cy: 25.36,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.46,
    cy: 25.12,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.62,
    cy: 27.11,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.9,
    cy: 26.93,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.96,
    cy: 26.91,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.82,
    cy: 27.53,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.9,
    cy: 27.13,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.84,
    cy: 27.58,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.36,
    cy: 27.19,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.28,
    cy: 27.15,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.91,
    cy: 27.2,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.46,
    cy: 27.49,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.41,
    cy: 27.14,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.64,
    cy: 27.18,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.62,
    cy: 26.97,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.02,
    cy: 27.27,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.83,
    cy: 29.38,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.06,
    cy: 29.38,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.98,
    cy: 29.42,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.02,
    cy: 29.42,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.92,
    cy: 28.96,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.17,
    cy: 29.39,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.35,
    cy: 29.48,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 29.11,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.4,
    cy: 28.99,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.87,
    cy: 29.64,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.71,
    cy: 29.05,
    r: 0.6,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.56,
    cy: 29.59,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.68,
    cy: 31.22,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.94,
    cy: 31.69,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.55,
    cy: 31.19,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.58,
    cy: 31.08,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.17,
    cy: 31.18,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.85,
    cy: 31.61,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.32,
    cy: 31.18,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.32,
    cy: 31.63,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.35,
    cy: 31.48,
    r: 0.43,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.8,
    cy: 31.38,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.59,
    cy: 31.55,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.25,
    cy: 31.42,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.74,
    cy: 31.16,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.11,
    cy: 31.07,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.85,
    cy: 31.39,
    r: 0.54,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.58,
    cy: 33.26,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.65,
    cy: 33.09,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.68,
    cy: 33.74,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.01,
    cy: 33.56,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.85,
    cy: 33.67,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.28,
    cy: 33.57,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.46,
    cy: 33.36,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.23,
    cy: 33.06,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.41,
    cy: 33.51,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.46,
    cy: 33.49,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.44,
    cy: 33.21,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.95,
    cy: 33.66,
    r: 0.44,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9,
    cy: 33.55,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.58,
    cy: 33.36,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.95,
    cy: 33.24,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.96,
    cy: 35.35,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.13,
    cy: 35.26,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.84,
    cy: 35.38,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.99,
    cy: 35.2,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.95,
    cy: 35.15,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.1,
    cy: 35.34,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.49,
    cy: 35.71,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.57,
    cy: 35.11,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.45,
    cy: 35.3,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.35,
    cy: 35.3,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.39,
    cy: 35.78,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 35.68,
    r: 0.54,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.97,
    cy: 35.37,
    r: 0.42,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.66,
    cy: 37.82,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.26,
    cy: 37.43,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.1,
    cy: 37.55,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.42,
    cy: 37.72,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.34,
    cy: 37.78,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.15,
    cy: 37.75,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.38,
    cy: 37.77,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.52,
    cy: 37.54,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.25,
    cy: 37.71,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.58,
    cy: 37.33,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.3,
    cy: 37.32,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.92,
    cy: 37.58,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.82,
    cy: 37.47,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.86,
    cy: 37.75,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.92,
    cy: 37.38,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.11,
    cy: 37.57,
    r: 0.59,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53,
    cy: 39.27,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.61,
    cy: 39.76,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.46,
    cy: 39.59,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.85,
    cy: 39.83,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.95,
    cy: 39.65,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.3,
    cy: 39.62,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.16,
    cy: 39.32,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.38,
    cy: 39.88,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.28,
    cy: 39.46,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.3,
    cy: 39.46,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.46,
    cy: 39.27,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.52,
    cy: 39.72,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.43,
    cy: 39.61,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.58,
    cy: 39.38,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.33,
    cy: 41.31,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.98,
    cy: 41.71,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.03,
    cy: 41.83,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.42,
    cy: 41.42,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.26,
    cy: 41.55,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.15,
    cy: 41.3,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.35,
    cy: 41.35,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.67,
    cy: 41.67,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.52,
    cy: 41.76,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.01,
    cy: 41.69,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.89,
    cy: 41.36,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.32,
    cy: 43.32,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.81,
    cy: 43.37,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.43,
    cy: 43.75,
    r: 0.42,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.01,
    cy: 43.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.02,
    cy: 43.54,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.33,
    cy: 43.44,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.37,
    cy: 43.44,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.41,
    cy: 43.72,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 43.72,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.42,
    cy: 43.44,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.25,
    cy: 43.55,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.7,
    cy: 43.92,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.71,
    cy: 43.55,
    r: 0.51,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.19,
    cy: 43.61,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.61,
    cy: 45.55,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.82,
    cy: 46.02,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.87,
    cy: 45.48,
    r: 0.45,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.69,
    cy: 46,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.86,
    cy: 45.7,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.96,
    cy: 45.94,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.85,
    cy: 45.77,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.24,
    cy: 45.81,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.92,
    cy: 45.97,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.09,
    cy: 45.53,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.72,
    cy: 45.68,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.13,
    cy: 45.56,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.73,
    cy: 47.57,
    r: 0.53,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.07,
    cy: 47.65,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.04,
    cy: 47.84,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.29,
    cy: 48,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.93,
    cy: 47.63,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.97,
    cy: 48.05,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.62,
    cy: 47.91,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.62,
    cy: 47.59,
    r: 0.59,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.06,
    cy: 47.67,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.79,
    cy: 47.85,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.26,
    cy: 47.59,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.53,
    cy: 49.99,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.62,
    cy: 49.72,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.22,
    cy: 49.72,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.96,
    cy: 49.8,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.16,
    cy: 49.46,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.31,
    cy: 50,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.65,
    cy: 49.84,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.6,
    cy: 50.13,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.22,
    cy: 49.85,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.88,
    cy: 49.91,
    r: 0.58,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.83,
    cy: 51.51,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.63,
    cy: 51.65,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.92,
    cy: 51.72,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.76,
    cy: 51.81,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.18,
    cy: 51.64,
    r: 0.55,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.1,
    cy: 51.79,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.88,
    cy: 51.56,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.24,
    cy: 51.69,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.25,
    cy: 51.9,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.36,
    cy: 52.04,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.3,
    cy: 51.77,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 51.65,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.47,
    cy: 51.56,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.18,
    cy: 51.71,
    r: 0.56,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.6,
    cy: 54.13,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.08,
    cy: 53.66,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.29,
    cy: 53.79,
    r: 0.55,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.15,
    cy: 54.18,
    r: 0.44,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.37,
    cy: 54.18,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.43,
    cy: 53.77,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.52,
    cy: 53.8,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.28,
    cy: 54.06,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.12,
    cy: 54.13,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.8,
    cy: 53.98,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.33,
    cy: 53.61,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.93,
    cy: 53.77,
    r: 0.53,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.98,
    cy: 53.77,
    r: 0.59,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.78,
    cy: 53.6,
    r: 0.54,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.14,
    cy: 54.14,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.98,
    cy: 55.71,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.88,
    cy: 55.95,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.06,
    cy: 56.07,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.28,
    cy: 55.73,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.08,
    cy: 56.03,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.72,
    cy: 55.75,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.34,
    cy: 56.25,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.43,
    cy: 56.21,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.11,
    cy: 56.03,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.48,
    cy: 57.69,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.1,
    cy: 58.16,
    r: 0.46,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.2,
    cy: 57.99,
    r: 0.48,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.28,
    cy: 58.24,
    r: 0.52,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.16,
    cy: 57.65,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.38,
    cy: 58.02,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.62,
    cy: 57.9,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.48,
    cy: 57.83,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.74,
    cy: 58.16,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.81,
    cy: 58.02,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.54,
    cy: 58.08,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.89,
    cy: 57.98,
    r: 0.57,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.03,
    cy: 57.98,
    r: 0.54,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.03,
    cy: 58.15,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.17,
    cy: 58.35,
    r: 0.41,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.71,
    cy: 58.35,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.08,
    cy: 60.13,
    r: 0.43,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.16,
    cy: 59.76,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3,
    cy: 59.86,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.09,
    cy: 60.29,
    r: 0.42,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.76,
    cy: 59.88,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.43,
    cy: 59.96,
    r: 0.48,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.52,
    cy: 59.84,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.14,
    cy: 59.83,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.08,
    cy: 59.85,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.96,
    cy: 60.37,
    r: 0.46,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.09,
    cy: 60.21,
    r: 0.46,
    opacity: 0.45
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo_light.2605bf79e8dd4737cb06b4a176aa0af0.svg";